import React from 'react';

import { useTasks } from '../context/tasks_context';
import PageHeader from 'components/ui/page_header';

export function TasksPageCount() {
  const { pagination, loading } = useTasks();

  if (!pagination) return null;

  return (
    <PageHeader.Count
      currentPage={pagination.currentPage}
      itemDescription="tasks"
      loading={loading}
      pageSize={pagination.pageSize}
      totalCount={pagination.totalCount}
    />
  );
}
